import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=fe91650a&scoped=true"
import script from "./blocks.vue?vue&type=script&lang=js"
export * from "./blocks.vue?vue&type=script&lang=js"
import style0 from "./blocks.vue?vue&type=style&index=0&id=fe91650a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe91650a",
  null
  
)

export default component.exports